import { render, staticRenderFns } from "./AppOfferResourcesField.vue?vue&type=template&id=dbd9536a&scoped=true"
import script from "./AppOfferResourcesField.vue?vue&type=script&lang=ts"
export * from "./AppOfferResourcesField.vue?vue&type=script&lang=ts"
import style0 from "./AppOfferResourcesField.vue?vue&type=style&index=0&id=dbd9536a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd9536a",
  null
  
)

export default component.exports